import { FC } from 'react';

import { MorePages } from './components/more-pages';

export const More: FC = () => <MorePages />;
